// src/components/ImageCropper.js

import React, { useState, useEffect, useContext } from 'react';
import Cropper from 'react-cropper';
import 'cropperjs/dist/cropper.css';
import axios from 'axios';
import { Button } from 'react-bootstrap';
import { LanguageContext } from '../contexts/LanguageContext';
import './ImageCropper.css'; // Import the CSS for styling

/**
 * ImageCropper Component
 * Allows users to crop the uploaded image before searching.
 */
function ImageCropper({ imageFile, onSearch, onCancel }) {
  const [cropperInstance, setCropperInstance] = useState(null);
  const { translations } = useContext(LanguageContext);

  useEffect(() => {
    const fetchBoundingBox = async () => {
      const formData = new FormData();
      formData.append('image', imageFile);

      try {
        const response = await axios.post('/api/get_bounding_box/', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });

        if (response.status === 200) {
          const { x_min, y_min, x_max, y_max } = response.data.bounding_box;

          if (cropperInstance) {
            const imageData = cropperInstance.getImageData();

            // Removed unused variables naturalWidth and naturalHeight

            const cropBoxData = {
              left: x_min * imageData.width + imageData.left,
              top: y_min * imageData.height + imageData.top,
              width: (x_max - x_min) * imageData.width,
              height: (y_max - y_min) * imageData.height,
            };

            cropperInstance.setCropBoxData(cropBoxData);
          }
        }
      } catch (error) {
        console.error('Error fetching bounding box:', error);
      }
    };

    if (imageFile && cropperInstance) {
      fetchBoundingBox();
    }
  }, [imageFile, cropperInstance]);

  /**
   * Handles the crop action and initiates the search.
   */
  const handleCrop = () => {
    if (cropperInstance) {
      cropperInstance.getCroppedCanvas().toBlob((blob) => {
        onSearch(blob);
      });
    }
  };

  return (
    <div>
      <Cropper
        src={URL.createObjectURL(imageFile)}
        style={{ height: 400, width: '100%' }}
        aspectRatio={0}
        guides={false}
        onInitialized={(instance) => {
          setCropperInstance(instance);
        }}
      />
      <div className="mt-3 d-flex justify-content-between">
        <Button variant="secondary" onClick={onCancel}>
          {translations.cancel}
        </Button>
        <Button variant="primary" onClick={handleCrop}>
          {translations.search}
        </Button>
      </div>
    </div>
  );
}

export default ImageCropper;
